import projection from '../generated/pwh508f1.json';
import { AcceptanceManifest } from '../types';
export const pwh508f1AcceptanceManifest = projection as AcceptanceManifest;
